export const LOGIN_PATH = '/login';
export const ACCESS_DENIED_PATH = '/access-denied';
export const OVERVIEW_PATH = '/';

export const path = (suffix: string) =>
  suffix.startsWith('/') ? suffix : `/${suffix}`;
